import React from 'react';
import {
  BankTypeEnum,
  BillingCheckIcon,
  CardsItemIcon,
} from '@common-fe/common-fe';

import spacings from '@/styles/spacings';

interface IconProps {
  cardType?: BankTypeEnum,
}

const DebitPaymentMethodIcon: React.FC<IconProps> = ({ cardType }) => {
  if (cardType === BankTypeEnum.VISA || cardType === BankTypeEnum.MASTERCARD || cardType === BankTypeEnum.AMEX) {
    return (
      <CardsItemIcon
        color="iconAccent"
        data-testid={`debit-payment-method-${cardType}`}
        size={spacings.l}
      />
    );
  }

  return (
    <BillingCheckIcon
      data-testid="debit-payment-method-default-icon"
      size={spacings.l}
      color="iconAccent"
    />
  );
};

export default DebitPaymentMethodIcon;
